import React, { lazy } from 'react';
export function HowItWorksSection() {
  const steps = [{
    title: 'Kies je vak',
    description: 'De leerling kiest uit 10 vakgebieden of start een gemengde oefensessie (Fluency mode).',
    color: 'bg-orange-500'
  }, {
    title: 'Oefen op jouw niveau',
    description: 'Het adaptieve systeem selecteert vragen op het juiste niveau (16 niveaus verdeeld over groep 6, 7 en 8).',
    color: 'bg-amber-400'
  }, {
    title: 'Krijg directe feedback',
    description: 'Bij elk antwoord: uitleg met oplossingsstappen, visuele hulpmiddelen en uitleg waarom foute antwoorden fout zijn.',
    color: 'bg-emerald-400'
  }, {
    title: 'Groei zichtbaar',
    description: 'Mastery-tracking per skill laat zien wat je beheerst. Ouders en leraren volgen de voortgang via hun portaal.',
    color: 'bg-blue-400'
  }];
  return <section id="hoe-het-werkt" className="py-16 lg:py-24 bg-white border-y border-slate-100 overflow-hidden" data-id="element-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-101">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-102">
          <div data-id="element-103">
            <div className="mb-12" data-id="element-104">
              <h2 className="text-3xl md:text-4xl font-extrabold text-slate-950 mb-4 tracking-tighter" data-id="element-105">
                Hoe werkt het? 🎯
              </h2>
              <p className="text-lg text-slate-600" data-id="element-106">
                Van de eerste klik tot volledige beheersing. Een naadloze
                leerervaring ontworpen voor maximale groei.
              </p>
            </div>

            <div className="space-y-8" data-id="element-107">
              {steps.map((step, index) => <div key={index} className="flex gap-4" data-id="element-108">
                  <div className={`w-10 h-10 shrink-0 rounded-full ${step.color} text-white flex items-center justify-center font-bold text-lg shadow-sm`} data-id="element-109">
                    {index + 1}
                  </div>
                  <div data-id="element-110">
                    <h3 className="text-xl font-bold text-slate-950 mb-2" data-id="element-111">
                      {step.title}
                    </h3>
                    <p className="text-slate-600 leading-relaxed" data-id="element-112">
                      {step.description}
                    </p>
                  </div>
                </div>)}
            </div>
          </div>

          <div className="relative flex justify-center lg:justify-end" data-id="element-113">
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-80 h-80 bg-orange-100 rounded-full blur-3xl -z-10" data-id="element-114" />
            <div className="relative w-[300px] rounded-[2.5rem] overflow-hidden shadow-2xl border-[8px] border-slate-900 bg-slate-900" data-id="element-115">
              <img src="https://cdn.magicpatterns.com/uploads/m9xpcthFsXLXBHhueqYFWC/screencapture-demo-meesterdjay-nl-2026-04-01-11_09_19.png" alt="Meester djay mobiele app" className="w-full h-auto" loading="lazy" data-id="element-116" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}